export default __webpack_public_path__ + "static/media/player_2_eliminated.b8d1d6d7.png";